'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = exports.drawerOpen = undefined;
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _styledSystem = require('styled-system');
var _index = require('./index');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var drawerOpen = exports.drawerOpen = function drawerOpen(_ref) {
  var open = _ref.open,
    position = _ref.position,
    size = _ref.size;
  var h = /^(left|right)$/.test(position) ? 1 : 0;
  var width = h ? size + 'px' : null;
  var height = h ? null : size + 'px';
  var transforms = {
    left: 'translateX(-100%)',
    right: 'translateX(100%)',
    top: 'translateY(-100%)',
    bottom: 'translateY(100%)'
  };
  var top = /^(top|left|right)$/.test(position) ? 0 : null;
  var bottom = /^(bottom|left|right)$/.test(position) ? 0 : null;
  var left = /^(left|top|bottom)$/.test(position) ? 0 : null;
  var right = /^(right|top|bottom)$/.test(position) ? 0 : null;
  return {
    width: width,
    height: height,
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    transform: open ? null : transforms[position]
  };
};
var Drawer = exports.Drawer = (0, _styledComponents2["default"])(_index.Fixed)([], _styledSystem.space, _styledSystem.color, _styledSystem.zIndex, drawerOpen, {
  position: 'fixed',
  overflowX: 'hidden',
  overflowY: 'auto',
  transitionProperty: 'transform',
  transitionDuration: '.2s',
  transitionTimingFunction: 'ease-out'
});
Drawer.defaultProps = {
  color: 'white',
  bg: 'dark',
  open: false,
  size: 320,
  position: 'left'
};
Drawer.displayName = 'Drawer';
exports["default"] = Drawer;